<style lang="scss" src="./attr_panel.scss"></style>

<script>
import { isFunction, isEmpty } from '@/utils'
import EventBus from '@/utils/event-bus.js'
import { MODULE } from "./wgts/const"

export default {
  name: 'AttrPanel',
  props: {
    info: [Object, Array],
    // value: [Object],
    widgets: [Array],
    activeUUID: ''
  },
  data() {
    return {
      // compValue: null,
      activeWgt: {},
      dWgtByList: [],
      value: {}
    }
  },
  watch: {
    activeUUID: function (nVal, oVal) {
      this.findWgtPathByUUID()
      this.findWgtByUUID()
      // this.findWgtByParent()
    }
  },
  created() {
    // this.compValue = this.value
  },
  methods: {
    findWgtPathByUUID() {
      function findPath(tree, targetName, currentPath = []) {
        for (const node of tree) {
          const path = [
            ...currentPath,
            {
              name: node.name,
              uuid: node.uuid,
              wgtName: node.wgtName,
              wgtDesc: node.wgtDesc
            }
          ]
          if (node.uuid === targetName) {
            return path
          }
          if (node.children && node.children.length > 0) {
            const result = findPath(node.children, targetName, path)
            if (result) {
              return result
            }
          }
        }
        return null
      }
      this.dWgtByList = findPath(this.info, this.activeUUID)
    },
    findWgtByUUID() {
      function findNode(tree, targetName) {
        for (const node of tree) {
          if (node.uuid === targetName) {
            return node
          }
          if (node.children && node.children.length > 0) {
            const result = findNode(node.children, targetName)
            if (result) {
              return result
            }
          }
        }
        return null
      }
      const foundNode = findNode(this.info, this.activeUUID)
      if (foundNode) {
        console.log('Found node:', foundNode)
        this.value = foundNode
      } else {
        console.log('Node not found.')
      }
    },
    // onCompChange() {
    //   this.$emit('input', this.compValue)
    // },
    _renderInput({ key }) {
      return <el-input type='text' v-model={this.value[key]} size='small' />
    },

    _renderColor({ key, value: initValue }) {
      // console.log('_renderColor:', this)
      return (
        <div class='el-color-picker-wrap'>
          <el-color-picker v-model={this.value[key]} size='small' />
          <el-button
            class='button-reset'
            type='text'
            on-click={() => {
              this.value[key] = initValue
            }}
          >
            重置
          </el-button>
        </div>
      )
    },

    _renderNumber({ key, placeholder, min, max, step = 1, size = 'small', position = '', disabled = false, append }) {
      return (
        <div style={'display: flex; align-items: center'}>
          <el-input-number placeholder={placeholder} v-model={this.value[key]} size={size} min={min} max={max} step={step} controls-position={position} disabled={disabled} />
          <span style={'margin-left: 5px;'}>{append}</span>
        </div>
      )
    },
    _renderSwitch({ key }) {
      return <el-switch v-model={this.value[key]} />
    },

    _renderSelect({ key, placeholder, options, clearable = true, multiple = false, onchange = () => { } }) {
      return (
        <el-select
          clearable={clearable}
          multiple={multiple}
          filterable
          v-model={this.value[key]}
          placeholder={placeholder || '请选择'}
          onChange={(e) => onchange(e, this)}
        >
          {options.map((op) => (
            <el-option label={op.name} value={op.label} />
          ))}
        </el-select>
      )
    },

    _renderSlider({ key, showInput = false }) {
      return (
        <el-slider v-model={this.value[key]} show-input={showInput} />
      )
    },
    _renderRadio({ key, options, onchange = () => { } }) {
      return (
        <el-radio-group v-model={this.value[key]} onChange={(e) => onchange(e, this)}>
          {options.map((op) => (
            <el-radio label={op.label}>{op.name}</el-radio>
          ))}
        </el-radio-group>
      )
    },
    // _renderSelect({ key, options, multiple = false, placeholder = '请选择' }) {
    //   return (
    //     <el-select v-model={this.value[key]} placeholder={placeholder} multiple={multiple} size='small'>
    //       {options.map((op) => (
    //         <el-option label={op.name} value={op.label} />
    //       ))}
    //     </el-select>
    //   )
    // },
    _renderRadioButton({ key, options, onchange = () => { } }) {
      return (
        <el-radio-group v-model={this.value[key]} size="mini" onChange={(e) => onchange(e, this)}>
          {options.map((op) => (
            <el-radio-button label={op.label}>{op.name}</el-radio-button>
          ))}
        </el-radio-group>
      )
    },
    _renderCheckbox({ key, options, min = 0, onchange = () => { } }) {
      return (
        <el-checkbox-group min={min} v-model={this.value[key]} onChange={(e) => onchange(e, this)}>
          {options.map((op) => (
            <el-checkbox label={op.label} key={op.label}>{op.name}</el-checkbox>
          ))}
        </el-checkbox-group>
      )
    },
  },
  render(h) {
    if (isEmpty(this.value)) {
      return null
    }

    const {
      config: { wgtName, setting }
    } = this.widgets.find((item) => item.name.toLowerCase() == this.value.name.toLowerCase())
    const wgts = setting.reduce((acc, config) => {
      const module = config.module || 'defualt';
      if (!acc[module]) {
        acc[module] = []; // 初始化module对应的数组
      }
      acc[module].push(config); // 将配置项添加到对应的数组中
      return acc;
    }, {});
    const renderComp = (item) => {
      if (isFunction(item.component)) {
        return item.component.call(this, h, item)
        // return <el-input v-model={this.value[item.key]} />
      }

      const renderItem = {
        // 'textarea': this._renderTextArea,
        'input': this._renderInput,
        'color': this._renderColor,
        'number': this._renderNumber,
        // 'text': this._renderText,
        'select': this._renderSelect,
        'radio': this._renderRadio,
        'radiobutton': this._renderRadioButton,
        'checkbox': this._renderCheckbox,
        // 'table': this._renderTable,
        // 'richText': this._renderRichText,
        // 'image': this._renderImage,
        'switch': this._renderSwitch,
        'slider': this._renderSlider,
      }
      return renderItem[item.component](item)
    }


    const _renderTitle = () => {
      return (
        <el-breadcrumb class='wgt-name' separator='/'>
          {this.dWgtByList.map((item) => (
            <el-breadcrumb-item>
              <span
                onClick={() => {
                  EventBus.$emit('active-wgt', item)
                }}
              >
                {item.wgtName}
                <span style={{fontSize: '10px',paddingLeft: '5px'}}>{item.wgtDesc}</span>
              </span>
            </el-breadcrumb-item>
          ))}
        </el-breadcrumb>
      )
    }

    return (
      <div class='attr-panel'>
        <div>{_renderTitle()}</div>
        {
          Object.entries(wgts).map(([key, value]) => (
            <div class='attr-panel-group'>
              <div class='attr-panel-group-title'>{MODULE[key]}</div>
              {value?.map((item, index) => (
                <div
                  class={[
                    'attr-panel-cell',
                    {
                      'is-show': typeof item.isShow != 'undefined' ? item.isShow.call(this, item) : true
                    }
                  ]}
                >
                  <div class='cell-label'>{item.label}{item.required && <span class='required'>*</span>}</div>
                  <div class='cell-value'>
                    <div class='cell-value-content'>{renderComp(item)}</div>
                    {item.tip && <div class='cell-value-tip' domPropsInnerHTML={item.tip} />}
                  </div>
                </div>
              ))}
            </div>)
          )
        }

      </div>
    )
  }
}
</script>
